import * as React from "react";
import { SVGProps } from "react";
export function SchoolIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={17}
      height={17}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#school_svg__a)"
        stroke="#535455"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M5.5 9.282H2.849A.849.849 0 0 0 2 10.13v3.45c0 .469.38.849.849.849H5.5M11.5 9.282h2.65c.47 0 .85.38.85.849v3.45a.85.85 0 0 1-.85.849H11.5M5.5 8.39a3 3 0 0 1 6 0v6.04h-6V8.39ZM8.5 5.39V1.57M8.5 1.57h3V3.5h-3V1.57Z" />
        <path d="M8.5 9.911a1.226 1.226 0 1 0 0-2.451 1.226 1.226 0 0 0 0 2.451ZM8.5 12.706l.008 1.724" />
      </g>
      <defs>
        <clipPath id="school_svg__a">
          <path fill="#fff" transform="translate(1.5 1)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
